import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { User } from 'state/types';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export function filterGroupsForUser(groups: VisitorGroup[], user: User | null): VisitorGroup[] {
  const isEntraLess = user?.isEntraLess!;
  return groups
    .filter((group) => group.type !== VisitorGroupType.AtlasInternal)
    .filter((group) => !Boolean(isEntraLess && group.type === VisitorGroupType.ExternalVisitors));
}
